import { apiHelper } from "./core"

const baseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const clinicalServiceBaseUrl =
  process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const getCurrentLoggedInUser = (): Promise<any> => {
  return apiHelper
    .get(`${baseUrl}/users/me`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getMedicalRecordIdByPatient = (patientId: any): Promise<any> => {
  return apiHelper
    .get(
      `${clinicalServiceBaseUrl}/chemo-order/unfilled-self-assessment?patientId=${patientId}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

// const getRoles = (data: any): Promise<any> => {
//   var data = {
//     mocRole:data,
//   }
//   return apiHelper
//     .post(`${userServiceBaseUrl}/users/switch-role`, body)
//     .then((response) => {
//       return response?.data
//     })
//     .catch((error) => {
//       return Promise.reject(error)
//     })
// }
const getRoles = (role: any, centerId: any): Promise<any> => {
  var url = ""
  if (
    role === "SYSTEM_ADMIN" ||
    role === "MRD" ||
    role === "MARKETING" ||
    role === "QUALITY" ||
    role === "ACCOUNTANT" ||
    role === "INSURANCE" ||
    role === "MANAGEMENT" ||
    role === "OPERATIONS"
  ) {
    url = `users/switch-role?mocRole=${role}`
  } else {
    if (role && centerId) {
      url = `users/switch-role?mocRole=${role}&centerId=${centerId}`
    }
  }

  return apiHelper
    .post(`${userServiceBaseUrl}/${url}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export { getCurrentLoggedInUser, getRoles, getMedicalRecordIdByPatient }
